import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import { API_BASE_URL } from "./config/api";
import "./index.css";
import App from "./App";

// Determine if we're in development or production
// Use the same logic as api.js for consistency
const isDevelopment = () => {
  // Check NODE_ENV first
  if (process.env.NODE_ENV === "development") {
    return true;
  }

  // Check hostname (localhost, 127.0.0.1, or any local IP)
  if (typeof window !== "undefined" && window.location) {
    const hostname = window.location.hostname;
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.startsWith("192.168.") ||
      hostname.startsWith("10.") ||
      hostname.endsWith(".local")
    ) {
      return true;
    }
  }

  // Check if port indicates development
  // Port 3000-3002: React dev server (client)
  // Port 4000: Node.js server (API) - also development
  if (typeof window !== "undefined" && window.location) {
    const port = window.location.port;
    if (
      port === "3000" ||
      port === "3001" ||
      port === "3002" ||
      port === "4000"
    ) {
      return true;
    }
  }

  return false;
};

// Configure axios default base URL
// API is directly accessible (no prefix needed)
axios.defaults.baseURL = API_BASE_URL;

// CRITICAL FIX: Polyfill for crypto.randomUUID to prevent browser extension errors
// This is needed because some browser extensions use crypto.randomUUID which isn't available in older browsers
if (typeof crypto !== "undefined" && !crypto.randomUUID) {
  crypto.randomUUID = function () {
    // Fallback UUID v4 implementation
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
}

// Add axios interceptor to handle authentication errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // If user doesn't exist in database, clear localStorage and redirect to login
    if (
      error.response?.status === 400 &&
      error.response?.data?.details?.includes("does not exist")
    ) {
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
